import { createSelector } from 'reselect';

export const selectModalData = createSelector(
  state => state.ui,
  state => state.data
);
